import { THERAPIST_ROUTES_PREFIX } from '../therapist-planning/therapist-planning.path';

export const COACH_PATIENT_CHAT_PATHNAME = `${THERAPIST_ROUTES_PREFIX}/chat/:user`;
export const COACH_PATIENT_STAT_PATHNAME = `${THERAPIST_ROUTES_PREFIX}/chat/:user/stats`;
export const COACH_PATIENT_STAT_PATH_DETAILS = `${THERAPIST_ROUTES_PREFIX}/chat/:user/stats/:challengeId`;
